'use client';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader } from '@heroui/react';
import { Search } from '@trwl/features/search';
import { Path } from '@trwl/shared/lib/router';
import { createStateful } from '@trwl/shared/lib/stateful';
import { Logo } from '@trwl/shared/ui/icons';
import { SEARCH } from '@trwl/store';
import { BrandSuggestion } from '@trwl/widgets/nav/search-sidebar/components/BrandSuggestion';
import { SeriesSuggestion } from '@trwl/widgets/nav/search-sidebar/components/SeriesSuggestion';
import cn from 'classnames';
import { useUnit } from 'effector-react';
import Link from 'next/link';
import { CgClose } from 'react-icons/cg';

import { ProductsSuggestion } from './components/ProductsSuggestion';
import { RecentSearch } from './components/RecentSearch';

export const SearchSidebar = createStateful(({ state, setState }) => {
  const isSearchEmpty = useUnit(SEARCH.$isSearchEmpty);
  const active = useUnit(state);
  return (
    <Drawer
      shouldBlockScroll
      isOpen={active.active}
      onOpenChange={(value) =>
        setState({
          active: value,
        })
      }
      motionProps={{
        variants: {
          enter: {
            opacity: 1,
            x: 0,
          },
          exit: {
            opacity: 0,
            x: 0,
          },
        },
      }}
      placement={'top'}
      radius="none"
      closeButton={
        <div>
          <CgClose
            className="cursor-pointer w-7 h-7 fill-[#B6B6B6]"
            onClick={() =>
              setState({
                active: false,
              })
            }
          />
        </div>
      }
      className={'max-h-full h-full md:h-auto'}
      classNames={{
        body: 'container w-full mx-auto px-4 max-w-[1120px] md:pb-4 md:min-h-[400px]',
        closeButton:
          'flex items-center justify-center [&>svg]:h-[30px] [&>svg]:w-[30px] [&>svg]:fill-primary text-primary hover:bg-transparent active:bg-transparent py-4 px-3 top-3',
        header:
          'flex flex-col items-center font-medium text-[26px] container w-full mx-auto px-4 max-w-[1120px]',
        footer: 'pb-safe-or-4',
        backdrop: 'max-sm:bg-white',
      }}
    >
      <DrawerContent>
        {(onClose) => (
          <>
            <DrawerHeader className={'py-2 md:py-1'}>
              <div
                className={'hidden md:block container my-1.5 xl:my-4 pr-[17px]'}
              >
                <div className="flex flex-row justify-center">
                  <Link href={Path.HOME}>
                    <Logo className={'h-[24px] md:h-[30px] lg:h-[32px]'} />
                  </Link>
                </div>
              </div>
            </DrawerHeader>
            <DrawerBody className={'gap-6'}>
              <div className={'flex gap-4 items-center'}>
                <Search onClose={onClose} />
                <div className={'w-7 h-7'}></div>
              </div>
              <div
                className={cn(
                  'grid grid-cols-1 gap-y-5 gap-x-8',
                  isSearchEmpty ? 'lg:grid-cols-2' : 'lg:grid-cols-3',
                )}
              >
                {isSearchEmpty ? (
                  <>
                    <RecentSearch onItemClick={onClose} />
                    <BrandSuggestion onItemClick={onClose} />
                  </>
                ) : (
                  <>
                    <BrandSuggestion onItemClick={onClose} />
                    <SeriesSuggestion onItemClick={onClose} />
                    <ProductsSuggestion onItemClick={onClose} />
                  </>
                )}
              </div>
              <Link
                target={'_blank'}
                href={'https://teletype.in/@trwl/item_search_trwl'}
                className={
                  'underline text-[#52525B] opacity-90 text-[16px] w-full text-center'
                }
              >
                Как найти любую пару?
              </Link>
            </DrawerBody>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
});
